import React from "react";
import { Col, Row } from "antd";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import styles from "src/styles";

// Helpers
import { getCarTitle } from "src/helpers/car.helper";

// Components
import GhostButton from "src/components/shared/button/GhostButton";

type Props = Car & {
    onClick?: () => void;
};

const SpecialDealCarCard = ({
    truck,
    size,
    gear,
    imageUrl,
    brand,
    model,
    numberOfDoors,
    numberOfSeats,
    price,
    onClick = () => {},
}: Props) => {
    const name = getCarTitle(brand, model);

    return (
        <DivStyled className="special-deal-car-card">
            <div className="container">
                <div className="content">
                    <div className="image">
                        <img src={imageUrl} alt={name} />
                    </div>
                    <div className="header">
                        <span>{name}</span>
                        <span>
                            <FormattedMessage
                                id="carCard.size"
                                values={{ value: size }}
                            />
                        </span>
                        <div className="body">
                            <Row gutter={[10, 10]}>
                                <Col span={12} className="item">
                                    <span className="label">
                                        <FormattedMessage id="carGear" />:
                                    </span>
                                    <span className="value">{gear}</span>
                                </Col>
                                <Col span={12} className="item">
                                    <span className="label">
                                        <FormattedMessage id="carTruck" />:
                                    </span>
                                    <span className="value">{truck}</span>
                                </Col>
                                <Col span={12} className="item">
                                    <span className="label">
                                        <FormattedMessage id="numberOfSeats" />:
                                    </span>
                                    <span className="value">
                                        {numberOfSeats}
                                    </span>
                                </Col>
                                <Col span={12} className="item">
                                    <span className="label">
                                        <FormattedMessage id="numberOfDoors" />:
                                    </span>
                                    <span className="value">
                                        {numberOfDoors}
                                    </span>
                                </Col>
                                <Col xs={24} className="item price">
                                    <span className="label">
                                        <FormattedMessage id="carCard.price" />:
                                    </span>
                                    <span className="value">
                                        <FormattedMessage
                                            id="xBahtPerDay"
                                            values={{ value: price }}
                                        />
                                    </span>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="footer">
                        <GhostButton onClick={onClick}>
                            <FormattedMessage id="carCard.reserveNow" />
                        </GhostButton>
                    </div>
                </div>
            </div>
        </DivStyled>
    );
};

const DivStyled = styled.div`
    &.special-deal-car-card {
        width: 315px;
        display: flex;
        justify-content: center;

        .container {
            width: 275px;
            padding: 0 20px;
            min-height: 405px;

            & > .content {
                background: linear-gradient(
                    180.05deg,
                    rgba(255, 255, 255, 0.2) 15.85%,
                    rgba(255, 255, 255, 0) 99.95%
                );
                filter: drop-shadow(0px 4px 44px rgba(53, 66, 79, 0.04));
                border-radius: 10px;
                padding: 0 12px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 100%;
            }
        }

        .image {
            display: flex;
            justify-content: center;
            height: 150px;
            padding-top: 10px;

            img {
                max-width: 315px;
                max-height: 150px;
                height: fit-content;
                width: fit-content;
            }
        }

        .header {
            display: grid;

            & > span {
                font-style: normal;
                font-weight: 600;
                font-size: 18px;
                line-height: 1.6;
                color: ${styles.fontColorWhite};

                @media screen and (max-width: 767px) {
                    font-size: 16px;
                }
            }
        }

        .body {
            font-size: 14px;
            line-height: 22px;
            color: ${styles.fontColorWhite};
            margin-top: 10px;

            .item > .label {
                margin-right: 4px;
            }

            .item.price {
                font-style: normal;
                font-weight: 600;
                font-size: 20px;
                line-height: 1.6;

                @media screen and (max-width: 767px) {
                    font-size: 18px;
                }
            }
        }

        .footer {
            .ant-btn.ant-btn-background-ghost {
                width: 100%;
                border-radius: 4px;
                margin-top: 32px;
                font-weight: 600;
                font-size: 18px;
                line-height: 1;

                @media screen and (max-width: 767px) {
                    font-size: 16px;
                }
            }
        }
    }
`;

export default SpecialDealCarCard;
